var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');

exports.GetBasicGlobalSearch = function(filter, sort, pageSize, pageNumber) {
  var qry = {
    filter: filter,
    pageSize: pageSize,
    pageNumber: pageNumber,
    sort: sort
  };
  return request.get(resolve(config.url(), '/search/basic'), qry).promise();
}

exports.GetAdvancedGlobalSearch = function(filter, type, sort, pageSize, pageNumber) {
  var qry = {
    filter: filter,
    pageSize: pageSize,
    type: type,
    pageNumber: pageNumber,
    sort: sort
  };
  return request.get(resolve(config.url(), '/search/advanced'), qry).promise();
}
